import { render, staticRenderFns } from "./RepairDetail.vue?vue&type=template&id=ce8168e4&"
import script from "./RepairDetail.vue?vue&type=script&lang=js&"
export * from "./RepairDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports